// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3Gw9c","legacyBtn":"MutateMid_legacyBtn__31OBv"};